<style lang="less">
.divider {
  display: block;
  height: 1px;
  width: 100%;
  clear: both;
  background: #e8e8e8;
  margin: 24px 0;
}
</style>

<template>
  <div class="divider" />
</template>

<script>
export default {
  name: "divider"
}
</script>
